import ArrowTopRightOnSquareIcon from "@heroicons/react/20/solid/ArrowTopRightOnSquareIcon";
import BookmarkIcon from "@heroicons/react/24/outline/BookmarkIcon";
import InformationIcon from "@heroicons/react/24/outline/InformationCircleIcon";
import ShareIcon from "@heroicons/react/24/outline/ShareIcon";
import BookmarkFilledIcon from "@mui/icons-material/Bookmark";
import LinkIcon from "@mui/icons-material/Link";
import { LoadingButton } from "@mui/lab";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import styled from "styled-components";
import Color from "../../../../assets/colors";

export const DivStyled = styling(Grid)((props) => ({
  //
}));

export const BoxStyled = styling(Box)((props) => ({}));

export const ApplyJobButton = styling(LoadingButton)((props) => ({
  textTransform: "capitalize",
  backgroundColor: "#31C47A",
  border: `1.5px solid ${Color.black}`,
  minWidth: "160px",
  width: "100%",
  height: "48px",
  borderRadius: "100px",
  fontWeight: "700",
  color: Color.white,
  fontSize: "16px",
  boxShadow: "none",

  "&:hover": {
    backgroundColor: Color.buttonHoverGreen,
  },

  [props.theme.breakpoints.down("lg")]: {
    minWidth: "230px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    minWidth: "200px",
  },
}));

export const BookmarkIconStyled = styling(BookmarkIcon)({
  width: "24px",
  height: "24px",
});

export const BookmarkFilledIconStyled = styling(BookmarkFilledIcon)({
  width: "24px",
  height: "24px",
  color: Color.hiredlyPurple,
});

export const ShareIconStyled = styling(ShareIcon)({
  width: "24px",
  height: "24px",
});

export const LinkIconStyled = styling(LinkIcon)({
  width: "24px",
  height: "24px",
  color: Color.white,
  margin: 0,
});

export const IconButtonStyled = styling(IconButton)((props) => ({
  position: "relative",
  width: "47px",
  height: "47px",
  border: `1.5px solid ${Color.black}`,
  color: Color.black,

  "&:hover": {
    backgroundColor: Color.lightGrey,
  },
}));

export const ShareButtonsContainer = styling(Grid)((props) => ({
  background: "#dcdcdc",
  position: "absolute",
  right: "55px",
  zIndex: "11",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  columnGap: "10px",
  width: "100%",
  maxWidth: "350px",
  borderRadius: "30px",
  padding: "10px 20px 10px",
  margin: "20px 0",
  minWidth: "285px",

  [props.theme.breakpoints.down("lg")]: {
    bottom: "70%",
    left: "-195px",
    minWidth: "310px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    left: "-240px",
    minWidth: "300px",
    bottom: "70%",
  },
}));

export const LoadingIndicator = styling(CircularProgress)((props) => {
  //
});

export const ClipboardContainer = styling(Grid)((props) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "50px",
  background: Color.darkGrey,
  cursor: "pointer",
  width: "32px",
  height: "32px",
}));

export const ArrowTopRightStyled = styling(ArrowTopRightOnSquareIcon)({
  height: "19px",
  width: "20px",
  margin: "0 -6px 0 6px",
});

export const ScrapedJobText = styling(Typography)((props) => ({
  marginTop: "8px",
  fontSize: "10px",
  lineHeight: "20px",
  letterSpacing: "1.5px",
  color: "#00000038",
}));

export const ExpiredCardStyled = styling(Card)((props) => ({
  borderRadius: "8px",
  height: "100%",
  boxShadow: "0 0 0 rgb(181 181 181 / 20%)",
  backgroundColor: "#ffcdd2",
  padding: "0 15px 0 15px",
}));

export const IconTextContainer = styling(Grid)((props) => ({
  display: "flex",
  margin: "10px 0",
  alignItems: "center",

  [props.theme.breakpoints.down("mobileL")]: {
    margin: "10px 0",
  },
}));

export const HeroInfoIcon = styling(InformationIcon)({
  color: "#b71c1c",
  width: "40px",
  marginRight: "10px",
});

export const LabelStyled = styling(Typography)({
  width: "100%",
  lineHeight: "1.4",
  letterSpacing: "0.05rem",
  fontSize: "14px",
  margin: 0,
  color: "#b71c1c",
  fontWeight: "700",
});

// A wrapper componen for rendering the sticky bottom apply button bar
// only render the sticky bottom when it is below desktop size and stickyBottom transient prop is true
export const ApplyContainer = styled(Box)`
  width: 100%;
  z-index: 10;
  border-top: ${(props) =>
    props.$stickybottom === "true" ? `1.5px solid ${Color.black}` : "unset"};
  border-bottom: ${(props) =>
    props.$stickybottom === "true" ? `1.5px solid ${Color.black}` : "unset"};
  background-color: ${(props) =>
    props.$stickybottom === "true" ? Color.white : "unset"};
  display: ${(props) => (props.$stickybottom === "true" ? "flex" : "unset")};
  justify-content: center;
  align-items: center;
  min-height: 70px;
  padding: 10px 0px;
`;
